import { MenuService } from '@core';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SsoLoginService } from '../sso-login.service';
import { environment } from '../../../../environments/environment';
import { UrlConfigService } from 'app/service/url-config.service';

@Component({
  selector: 'app-sso-login',
  template: `
    <div style="height: 100%;width: 100%;background-color: white;"></div>
  `,
  styleUrls: ['./sso-login.component.scss'],
})
export class SsoLoginComponent implements OnInit {
  tokenDetails: any;
  loginDetails: any;
  userDetailsObj: any;
  landingResponse: any;
  taskOpen: any;
  TOKEN = 'token';

  USER_NAME = 'authenticatedUser';
  USER_TEAM_TYPE = 'userTeamType';
  USER_EMAIL = 'email';
  CLIENT_LIST = 'clientList';
  TIME_OFFSET = 'timeOffset';
  MENU_LIST = 'menulist';
  userTeamType: string;

  url: string;

  constructor(
    private router: Router,
    private _ssoLoginService: SsoLoginService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private menuService: MenuService,
    private httpClient: HttpClient,
    private urlConfigService: UrlConfigService
  ) {
    //this.generateSsoToken();
    this.url = this.urlConfigService.apiServerUrl;
    this.ssoLogin();
  }

  generateSsoToken() {
    let navigationExtras: NavigationExtras;
    navigationExtras = {
      queryParams: {},
    };
    var url = window.location.href;
    var urlArray = url.split('?');
    this._ssoLoginService.generateSsoToken(urlArray[1]).subscribe(res => {
      this.tokenDetails = res;
      if (true) {
        let jwtObj = {
          domain: this.tokenDetails.domain,
          winUserID: this.tokenDetails.winUserId,
          uuid: this.tokenDetails.UUID,
          ssoParam: this.tokenDetails.ssoparam,
          appName: this.tokenDetails.appName,
        };

        let headers = new HttpHeaders({
          'Content-Type': 'application/json',
        });
        try {
          this.httpClient
            .post(this.url + 'sso/ssoLogin', jwtObj, {
              headers,
              responseType: 'text',
            })
            .subscribe(
              response => {
                this.landingResponse = JSON.parse(response);
                this.registerSuccessfulLogin(
                  this.landingResponse.USER_DETAILS.username,
                  this.landingResponse.TOKEN,
                  this.landingResponse.USER_DETAILS.emailAddress,
                  this.landingResponse.userTeamType,
                  this.landingResponse.clientList,
                  this.landingResponse.menu
                );

                if (true) {
                  this.userDetailsObj = this.landingResponse.USER_DETAILS;
                  this.userDetailsObj.salt = '';
                  this.storage.set('userDetails', this.userDetailsObj);
                  //this.token.saveToken(this.landingResponse.TOKEN);
                  //this.storage.set("userMenu", this.landingResponse.MENU);

                  this.userTeamType = localStorage.getItem('userTeamType');
                  if (this.userTeamType == 'Auditee Area') {
                    this.router.navigate(['/auditeehome/auditeehome'], navigationExtras);
                  } else {
                    this.router.navigate(['/auditorhome/auditorhome'], navigationExtras);
                  }
                } else {
                  this.router.navigate(['/login'], navigationExtras);
                }
              },
              error => {
                this.router.navigate(['/login'], navigationExtras);
              }
            );
        } catch (Exception) {
          this.router.navigate(['/login'], navigationExtras);
        }
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  ngOnInit() {}

  ssoLogin() {
    let navigationExtras: NavigationExtras;
    navigationExtras = {
      queryParams: {},
    };
    var url = window.location.href;
    var urlArray = url.split('?');

    let jwtObj = {
      domain: urlArray[1],
      winUserID: urlArray[0],
    };

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    try {
      this.httpClient.post(url, jwtObj, { headers, responseType: 'text' }).subscribe(
        response => {
          this.landingResponse = JSON.parse(response);
          this.registerSuccessfulLogin(
            this.landingResponse.USER_DETAILS.username,
            this.landingResponse.TOKEN,
            this.landingResponse.USER_DETAILS.emailAddress,
            this.landingResponse.userTeamType,
            this.landingResponse.clientList,
            this.landingResponse.menu
          );

          if (true) {
            this.userDetailsObj = this.landingResponse.USER_DETAILS;
            this.userDetailsObj.salt = '';
            this.storage.set('userDetails', this.userDetailsObj);
            //this.token.saveToken(this.landingResponse.TOKEN);
            //this.storage.set("userMenu", this.landingResponse.MENU);

            this.userTeamType = localStorage.getItem('userTeamType');
            if (this.userTeamType == 'Auditee Area') {
              this.router.navigate(['/auditeehome/auditeehome'], navigationExtras);
            } else {
              this.router.navigate(['/auditorhome/auditorhome'], navigationExtras);
            }
          } else {
            this.router.navigate(['/login'], navigationExtras);
          }
        },
        error => {
          this.router.navigate(['/login'], navigationExtras);
        }
      );
    } catch (Exception) {
      this.router.navigate(['/login'], navigationExtras);
    }
  }

  registerSuccessfulLogin(username, token, email, userTeamType, clientList, menuList) {
    menuList = menuList.toString();
    localStorage.setItem(this.USER_NAME, username);
    localStorage.setItem(this.TOKEN, token);
    localStorage.setItem(this.USER_EMAIL, email);
    localStorage.setItem(this.USER_TEAM_TYPE, userTeamType);
    localStorage.setItem(this.CLIENT_LIST, JSON.stringify(clientList));
    localStorage.setItem(this.MENU_LIST, menuList);
  }
}
